import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { BucketFile } from "src/api/types";
import { useIsMobile } from "src/hooks/useIsMobile";

const mapFileToLabel: Record<string, { label: string; key: string }> = {
  "front-of-card.jpeg": { label: "Front", key: "front-card" },
  "back-of-card.jpeg": { label: "Back", key: "back-card" },
};

interface Props {
  file: BucketFile;
}

const FileView = ({ file }: Props) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const component = `file-view`;

  const map = mapFileToLabel[file.name];

  return (
    <Stack
      key={file.name}
      width={isMobile ? "80%" : "60%"}
      order={map.key === "front-card" ? 0 : 1}
    >
      <Box>
        <Link to={file.url} target="_blank">
          <img src={file.url} alt={file.name} width={"100%"} />
        </Link>
      </Box>
      <Typography fontWeight={600}>
        {t(`${component}.${map.key}`, map.label)}
      </Typography>
    </Stack>
  );
};

export default FileView;
